document.addEventListener('DOMContentLoaded', function() {
    const wishlistButton = document.getElementById('add-to-wishlist-btn');

    if (wishlistButton) {
        // Check the state in localStorage
        const variantId = wishlistButton.getAttribute('data-variant-id');
        const isInWishlist = localStorage.getItem(`wishlistBtnState_${variantId}`) === 'added';

        if (isInWishlist) {
            // Update button to indicate that the product is in the wishlist
            wishlistButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" fill="currentColor" class="bi bi-heart-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
</svg><p>Added to Wishlist</p>`;
        }

        // Add event listener to toggle wishlist on button click
        wishlistButton.addEventListener('click', function() {
            const product = {
                productTitle: wishlistButton.getAttribute('data-product-title'),
                productUrl: wishlistButton.getAttribute('data-product-url'),
                productImg: wishlistButton.getAttribute('data-product-img'),
                productPrice: wishlistButton.getAttribute('data-product-price'),
                variantId: wishlistButton.getAttribute('data-variant-id')
            };

            // Call the wishlist function
            toggleWishlist(product);
        });
    } else {
        console.error('Button with id "add-to-wishlist-btn" not found!');
    }
});
    // Initialize the wishlist from localStorage
  function displayWishlist(product) {
    const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
    const wishlistBlock = document.querySelector('.js-wishlistBlock'); // Ensure this element exists

    let wishlistHtml;

    if (wishlistData.length === 0) {
        wishlistHtml = '<p>No items in your wishlist yet.</p><button class = "button button--outline"><a href = "/collections/chairs">Back to Products</a></button>';
    } else {
        wishlistHtml = wishlistData.map(item => `
            <div class="wishlist-product__list">
                <div class="c-product wishlist-flex">
                    <div class="col-4">
                        <a href="${item.productUrl}"class = "wishlistThumbnail">
                            <img src="${item.productImg}" alt="${item.productTitle}" width = "110px" height = "110px">
                        </a>
                    </div>
                    <div class="col-8">
                        <span><b>${item.productTitle}</b></span>
                        <p>${item.productPrice}</p>
                        <button class="remove-btn" onclick="removeFromWishlist('${item.productTitle}')">Remove</button>
                        <button class="add-to-cart-btn" onclick="addToCart('${item.variantId}')">Add to Cart</button>
                    </div>
                </div>
            </div>
        `).join('');
    }

    // Ensure wishlistBlock exists before trying to set innerHTML
    if (wishlistBlock) {
        wishlistBlock.innerHTML = wishlistHtml;
    } else {
        console.error('Wishlist block not found!');
    }
}
    // Add product to wishlist
    function addToWishlist(product) {
        let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
        if (!wishlistData.some(item => item.productTitle === product.productTitle)) {
            wishlistData.push(product);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));
            alert('Product added to wishlist!');
        }
        displayWishlist();
    }

    // Remove product from wishlist
    function removeFromWishlist(productTitle) {
        let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
        wishlistData = wishlistData.filter(item => item.productTitle !== productTitle);
        localStorage.setItem('wishlist', JSON.stringify(wishlistData));
        displayWishlist();
    }

   function addToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: variantId, // Use the variant ID for the product
            quantity: 1 // Default quantity
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        alert('Product added to cart!');
        console.log('Product added to cart:', data);
    })
    .catch(error => {
        console.error('Error adding product to cart:', error);
        alert('Failed to add product to cart. Please try again.');
    });
}

    // Initialize the wishlist display when the page loads
    document.addEventListener('DOMContentLoaded', displayWishlist);

 function toggleWishlist(pdpData) {
    try {
        // Fetch wishlist data from localStorage or initialize an empty array
        let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

        // Check if the product is already in the wishlist
        const isAlreadyInWishlist = wishlistData.some(item => item.productTitle === pdpData.productTitle);

        const wishlistButton = document.querySelector('.wishlist-btn'); // Assuming you have a class for the wishlist button

        if (!isAlreadyInWishlist) {
            // Product is not in the wishlist, so add it
            wishlistData.push(pdpData);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));

            // Save the state that this product is in the wishlist
            localStorage.setItem(`wishlistBtnState_${pdpData.variantId}`, 'added');

            // Update button to indicate that the product is in the wishlist
            wishlistButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" fill="currentColor" class="bi bi-heart-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
</svg><p>Added to Wishlist</p>`;
        } else {
            // Product is already in the wishlist, so remove it
            wishlistData = wishlistData.filter(item => item.productTitle !== pdpData.productTitle);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));

            // Remove the state that this product is in the wishlist
            localStorage.removeItem(`wishlistBtnState_${pdpData.variantId}`);

            // Update button to indicate that the product is no longer in the wishlist
            wishlistButton.innerHTML = `<svg class="heart-outline" width="32px" height="32px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="0" fill="none" width="24" height="24"/><g><path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/></g></svg> <p>Add to Wishlist</p>`;
        }
    } catch (error) {
        console.error('Error handling wishlist:', error);
        alert('There was an issue with updating your wishlist. Please try again.');
    }
}
